import { PURGE } from 'redux-persist';
import { setToken } from '../axios';
import ViewStateManager from '../../utils/viewStateManager';

var initialState = {
  message: '',
  isLogin: false,
  isLoading: false,
  isLoadButton: false,
  role: localStorage.getItem('role'),
  auth: localStorage.getItem('token'),
  userId: localStorage.getItem('userId'),

  analytics: {},
  searchResponse: {},
  analyticsRange: 'All time',

  // 2FA state
  require2FA: false,
  twoFAData: null,

  // Password setup state - persist across refreshes
  requiresPasswordSetup: localStorage.getItem('requiresPasswordSetup') === 'true'
}

const Auth = (state = initialState, { type, payload }) => {
  switch (type) {
    case PURGE: 
      ViewStateManager.clearAll();
      return initialState;

    /*========== LOGIN REDUCERS ============= */

    case 'TOGGLE_LOGIN':
      return { ...state, isLogin: !state['isLogin'] };

    case 'SAVE_LOGIN_DATA':
      setToken(payload['token']);
      localStorage.setItem('role', payload['role']);
      localStorage.setItem('userId', payload['_id']);
      localStorage.setItem('token', payload['token']);
      if (payload['user']) { localStorage.setItem('user', JSON.stringify(payload['user'])); }
      return { ...state, role: payload['role'], auth: payload['token'], userId: payload['_id'] }
  
    case 'GET_ANALYTICS':
      return { ...state, isLoadButton: true }

    case 'SET_ANALYTICS':
      return { ...state, analytics: payload, isLoadButton: false }

    case 'SET_ANALYTICS_RANGE':
      return { ...state, analyticsRange: payload }

    case 'SET_LOAD_BUTTON':
      return { ...state, isLoadButton: payload }

    case 'GET_ME':
      return { ...state, isLoading: true, message: 'Setting up your workspace...' }

    case 'SET_USER_DETAILS':
      return { ...state, isLoading: false, message: '' }

    case 'GET_SEARCH_RESULTS':
      return { ...state, isLoadButton: true }
    case 'SET_SEARCH_RESPONSE':
      return { ...state, searchResponse: payload, isLoadButton: false }

    case 'SET_2FA_REQUIRED':
      return { ...state, require2FA: true, twoFAData: payload }

    case 'CLEAR_2FA_STATE':
      return { ...state, require2FA: false, twoFAData: null }

    case 'SET_REQUIRES_PASSWORD_SETUP':
      // Persist to localStorage so it survives page refresh
      if (payload) localStorage.setItem('requiresPasswordSetup', 'true');
      else localStorage.removeItem('requiresPasswordSetup');
      return { ...state, requiresPasswordSetup: payload }

    case 'LOGOUT':
      setToken();
      // Clear all localStorage items
      localStorage.clear();
      ViewStateManager.clearAll();
      return { ...initialState, auth: '', role: '', requiresPasswordSetup: false }

    default:
      return state;
  }
};
export default Auth;
